import WhyChooseGrid from "./WhyChooseGrid";

/**
 * QA & regulatory compliance checklist. Same checklist layout as WhyChooseGrid,
 * rendered on a white surface (the compliance band sits between grey sections in
 * the Figma). Kept as its own type so pages read semantically.
 */
export default function ComplianceSection(props) {
  return <WhyChooseGrid {...props} surface="light" />;
}
